import GoogleMapReact from 'google-map-react';
import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import { defaultZoom } from 'src/constants/map';
import { appStore } from 'src/mobx/appStore';
import Indicator from 'src/view/components/Controls/Indicator/Indicator';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import './style.scss';

interface Props {
  isOpen: boolean;
  coordinats: {
    lat: number;
    lng: number;
  };
  closePopup: () => void;
}

export default class MapPopup extends Component<Props, {}> {
  render() {
    return (
      <CustomModalComponent
        isOpen={this.props.isOpen}
        onRequestClose={this.props.closePopup}
        withCloseIcon
        className="map-popup"
        iconClassName="color-dark"
        shouldCloseOnOverlayClick
      >
        <div className="map-popup__iframe-container">
          {this.props.coordinats.lat && this.props.coordinats.lng ? (
            <GoogleMapReact
              zoom={15}
              bootstrapURLKeys={{
                key: appStore.settings?.google_maps_pk || '',
                libraries: ['geometry'],
              }}
              // style={{ style: { display: 'flex', flex: 1 } }}
              // onGoogleApiLoaded={async () => {
              //   this.setState({ ready: true, zoom: this.map.map_.zoom });
              // }}
              // center={{
              //   lat: this.props.order.latitude,
              //   lng: this.props.order.longitude,
              // }}
              center={this.props.coordinats}
              defaultZoom={defaultZoom}
              yesIWantToUseGoogleMapApiInternals
              options={{
                fullscreenControl: false,
                gestureHandling: 'greedy',
                zoomControl: true,
                scrollwheel: true,
                draggable: false,
              }}
            >
              <Indicator className="map-popup__iframe-indicator" lat={this.props.coordinats.lat} lng={this.props.coordinats.lng} />
            </GoogleMapReact>
          ) : (
            <Skeleton width={640} height={378} />
          )}
        </div>
      </CustomModalComponent>
    );
  }
}
